/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureScanningAccountSetupStatus200Response {
  /**
  * The ID of the workflow
  */
  'workflowId': string;
  /**
  * The current status of the workflow
  */
  'status': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "workflowId",
      "baseName": "workflowId",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return AzureScanningAccountSetupStatus200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

